import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ValidationHelperService} from "../../../../../../../core/helpers/validation-helper.service";
import {FormGroup} from "@angular/forms";
import {IAccountInformationForm, IAddressForm} from "../../../../core/forms/account-information/account-information-form.interface";
import {
    IAddress,
    IGetAccountInformationResponse
} from "../../../../../../../core/api/controllers/account-controller/interfaces/get-account-information.response";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-account-information-form',
  templateUrl: './account-information-form.component.html',
  styleUrls: ['./account-information-form.component.scss']
})
export class AccountInformationFormComponent {
    @Input() _form: FormGroup<IAccountInformationForm>;
    @Input() prefillInformation: IGetAccountInformationResponse;
    @Output() _submit = new EventEmitter();
    @Output() _cancel = new EventEmitter();
    $triggerCopyShipping = new BehaviorSubject<IAddress>(null);
    protected readonly ValidationHelperService = ValidationHelperService;

    copyShipping(): void {
        this.$triggerCopyShipping.next(this.createAddressFromForm(this._form.controls.organization.controls.shippingAddress.controls));
    }

    createAddressFromForm(form: IAddressForm): IAddress {
        return {
            addressLine1: form.addressLine1.value,
            addressLine2: form.addressLine2.value,
            city: {
                id: form.city.value.id,
                name: form.city.value.name
            },
            country: {
                id: form.country.value.id,
                name: form.country.value.name
            },
            state: {
                id: form.state.value.id,
                name: form.state.value.name
            },
            zipCode: form.zipCode.value
        } as IAddress;
    }

    onSubmit(): void {
        this._form.markAllAsTouched();
        if(this._form.valid) {
            this._submit.emit(this._form.value);
        }
    }
}
